(function () {
  console.log("[Tidio Control] Script initialized.");

  // We'll set Tidio to z-index=9 on script start (both desktop & mobile).
  // Then, on mobile, if Tidio opens, we move it up to z-index=9999.
  // On desktop, it always stays at 9, even when opened.

  let tidioOpen = false; // Track Tidio's open/close state
  let debounceTimeout;   // Debounce mechanism

  function monitorTidioState() {
    const tidioContainer = document.getElementById("tidio-chat");

    if (!tidioContainer) {
      console.warn("[Tidio Control] ❌ Tidio chat container not found. Retrying...");
      setTimeout(monitorTidioState, 500); // Retry if Tidio hasn't loaded yet
      return;
    }

    // Initially set z-index=9 on page load for all devices
    tidioContainer.style.zIndex = "9";
    console.log("[Tidio Control] Set Tidio z-index to 9 on load (all devices).");

    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        const tidioIframe = tidioContainer.querySelector("iframe");
        if (!tidioIframe) {
          console.warn("[Tidio Control] ❌ Tidio iframe not found.");
          return;
        }

        // Check if Tidio is open by looking at iframe bottom style
        const iframeStyle = window.getComputedStyle(tidioIframe);
        const isTidioOpen = iframeStyle.bottom === "0px";
        const isMobile = window.innerWidth <= 767;

        // Only update z-index when there's an actual change (open -> close or close -> open)
        if (isTidioOpen && !tidioOpen) {
          tidioOpen = true;
          if (isMobile) {
            // On mobile, set z-index=9999 when open
            tidioContainer.style.zIndex = "9999";
            console.log("[Tidio Control] Tidio opened (mobile). Setting z-index to 9999.");
          } else {
            // On desktop, stay at 9 even when open
            tidioContainer.style.zIndex = "9";
            console.log("[Tidio Control] Tidio opened (desktop). Staying at z-index=9.");
          }
        } else if (!isTidioOpen && tidioOpen) {
          tidioOpen = false;
          // When closed, always reset to z-index=9 (both desktop & mobile)
          tidioContainer.style.zIndex = "9";
          console.log("[Tidio Control] Tidio closed. Resetting z-index to 9 (both desktop & mobile).");
        }
      }, 100);
    });

    observer.observe(tidioContainer, { attributes: true, childList: true, subtree: true });
  }

  function initializeTidioControl() {
    console.log("[Tidio Control] Initializing...");
    monitorTidioState();
  }

  // Run script immediately
  initializeTidioControl();
})();
